<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Modul Pembelajaran',
                    to: { path: '/modul-pembelajaran' },
                    exact: true,
                },
                {
                    text: 'Laporan Modul',
                    to: { path: '/modul-pembelajaran/report' },
                    exact: true,
                },
                { text: 'Detail Laporan' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="font-weight-bold font-size-20 mt-3 mb-5">
            Detail Laporan
        </div>

        <v-card flat class="mb-10">
            <v-card-title class="border-bottom py-3">
                <div class="font-size-16 black--text">
                    {{ data.module.subject }}
                </div>
            </v-card-title>
            <v-card-text class="pt-5">
                <v-row>
                    <v-col>
                        <div>
                            <label> Nama Modul </label>
                            <v-text-field
                                v-model="data.module.name"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                    <v-col>
                        <div>
                            <label> Judul Modul </label>
                            <v-text-field
                                v-model="data.module.name"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <div>
                            <label> Semester </label>
                            <v-text-field
                                v-model="data.module.semester"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                    <v-col>
                        <div>
                            <label> Bab </label>
                            <v-text-field
                                v-model="data.module.bab"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <div>
                            <label> Subbab </label>
                            <v-text-field
                                v-model="data.module.subab"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                    <v-col>
                        <div>
                            <label> Tanggal Laporan </label>
                            <v-text-field
                                v-model="data.created_at"
                                outlined
                                dense
                                disabled
                                class="mt-1"
                            />
                        </div>
                    </v-col>
                </v-row>

                <div>
                    <label> Kategori Laporan </label>
                    <v-text-field
                        v-model="data.report_category"
                        outlined
                        dense
                        disabled
                        class="mt-1"
                    />
                </div>

                <div>
                    <label> Detail Laporan </label>
                    <v-text-field
                        v-model="data.report_detail"
                        outlined
                        dense
                        disabled
                        class="mt-1"
                    />
                </div>

                <div v-if="data.url_image.length > 0">
                    <label> Hasil Unggahan </label>

                    <v-card
                        v-for="(item, i) in data.url_image"
                        :key="i"
                        outlined
                        class="mt-1"
                    >
                        <v-card-text class="pa-3">
                            <div
                                class="d-flex justify-space-between align-center"
                            >
                                <span class="font-weight-bold primary--text">
                                    <v-icon
                                        class="mr-2"
                                        style="font-size: 18px !important"
                                        color="primary"
                                        >mdi-image</v-icon
                                    >{{ getShortName(item) }}</span
                                >

                                <div>
                                    <v-btn
                                        text
                                        depressed
                                        class="font-weight-bold blew--text mt-0"
                                        style="background-color: #e1f4fc"
                                        color="#e8f5fa"
                                        @click="openImage(item)"
                                    >
                                        Lihat Gambar
                                    </v-btn>

                                    <v-btn
                                        text
                                        depressed
                                        class="font-weight-bold blew--text mt-0"
                                        style="background-color: #e1f4fc"
                                        color="#e8f5fa"
                                        @click="downloadImage(item)"
                                    >
                                        <v-icon
                                            style="font-size: 18px !important"
                                            >mdi-download</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>

                <div>
                    <label> Status </label>

                    <v-radio-group row v-model="data.status">
                        <v-radio
                            label="To Do"
                            value="TO_DO"
                            class="radio-custom"
                            active-class="act-radio-btn"
                        ></v-radio>

                        <v-radio
                            label="In Progress"
                            value="IN_PROGRESS"
                            class="radio-custom"
                            active-class="act-radio-btn"
                        ></v-radio>

                        <v-radio
                            label="Done"
                            value="DONE"
                            class="radio-custom"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </div>
            </v-card-text>

            <v-card-actions class="py-4 px-5 border-top-1">
                <v-spacer />
                <v-btn
                    depressed
                    color="blew"
                    class="white--text"
                    @click="updateStatus()"
                    >Simpan</v-btn
                >
            </v-card-actions>
        </v-card>

        <v-dialog
            v-if="openDialogImage"
            v-model="openDialogImage"
            @click:outside="openDialogImage = false"
            max-width="90vw"
            max-height="90vh"
        >
            <v-card class="d-flex flex-column align-center">
                <v-card-text class="pa-0">
                    <v-img
                        :src="imageShow"
                        class="img-fluid"
                        contain
                        max-width="100%"
                        max-height="80vh"
                    ></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AppSpinner from "@/components/plugins/Spinner";
import axios from "axios";
import moment from "moment";

export default {
    components: {
        "app-spinner": AppSpinner,
    },

    data() {
        return {
            loading: false,
            data: {
                module: {
                    subject: "",
                    name: "",
                    bab: "",
                    subab: "",
                    semester: "",
                },
                created_at: null,
                report_category: "",
                report_detail: "",
                url_image: [],
                status: "",
            },
            openDialogImage: false,
            imageShow: null,
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData: function () {
            var id = this.$route.query.id;
            var context = this;
            this.isLoading = true;

            const url = `${process.env.API_BASE_URL}itembank/report/modules/get-detail/${id}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                context.isLoading = false;

                if (response.status === 200) {
                    (context.data.module.name = response.data.module.name),
                        (context.data.module.bab = response.data.module.bab),
                        (context.data.module.subab =
                            response.data.module.subab),
                        (context.data.module.semester =
                            response.data.module.semester),
                        (context.data.module.subject =
                            response.data.module.subject),
                        (context.data.created_at = moment(
                            response.data.created_at
                        ).format("DD MMM YYYY")),
                        (context.data.report_category =
                            response.data.report_category),
                        (context.data.report_detail =
                            response.data.report_detail),
                        (context.data.url_image = response.data.url_image),
                        (context.data.status = response.data.status);
                } else {
                    this.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan Mengambil Data!`,
                        type: "error",
                    });
                }
            });
        },

        updateStatus: function () {
            var id = this.$route.query.id;
            var context = this;

            this.isLoading = true;

            var param = {
                status: context.data.status,
            };

            const url = `${process.env.API_BASE_URL}itembank/report/modules/${id}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.put(url, param, options).then(function (response) {
                if (response.status === 200) {
                    context.$store.commit("showAlert", {
                        message: response.data.description,
                        type: "success",
                    });
                    context.$router.push("/modul-pembelajaran/report");
                } else {
                    context.isLoading = false;
                    context.$store.commit("showAlert", {
                        message: response.data.description,
                        type: "error",
                    });
                }
            });
        },

        getShortName(filename) {
            var maxLength = 50;
            if (filename.length > maxLength) {
                return filename.substring(0, maxLength) + "...";
            }
            return filename;
        },

        openImage(image) {
            this.openDialogImage = true;
            this.imageShow = image;
        },

        downloadImage(image) {
            var imageUrl = image;
            var fileName = "downloaded-image.jpg";

            var link = document.createElement("a");
            link.href = imageUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

<style>
.radio-custom {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 5000px;
}
</style>



// WEBPACK FOOTER //
// ModulReportDetail.vue?441dcba3